import useAction from "./useAction";

const LABEL_SCHEDULE_ENABLED = "Schedule is running";

type Props = {
  scheduleId?: string;
  enableSchedule: (scheduleId: string) => Promise<unknown>;
};

const useEnable = ({ scheduleId, enableSchedule }: Props) => {
  const { onAction: onEnableSchedule, isLoading } = useAction({
    scheduleId,
    action: enableSchedule,
    successMessage: LABEL_SCHEDULE_ENABLED,
  });

  return { onEnableSchedule, isLoading };
};

export default useEnable;

